import script from "./ReviewSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewSection.vue?vue&type=script&setup=true&lang=js"

import "./ReviewSection.vue?vue&type=style&index=0&id=797e1b80&lang=css"

const __exports__ = script;

export default __exports__